<!-- renders vuetify autocomplete comp with max items logic  -->

<template>
	<v-autocomplete
		:density="density || 'compact'"
		:class="['custom-input', 'custom-chips']"
		:variant="variant || 'outlined'"
		:color="color || 'primary'"
		:label="label"
		:items="items"
		:item-title="itemTitle || 'title'"
		:item-value="itemValue || 'value'"
		:clearable="clearable"
		:model-value="modelValue"
		:multiple="multiple"
		@update:modelValue="handleModelUpdate"
	>
	</v-autocomplete>
</template>

<script setup lang="ts">

// Prevent attribute inheritance since we manually handle them
defineOptions({
	inheritAttrs: false,
});

interface AutocompleteProps {
	items: any[];
	modelValue?: any;
	label?: string;
	itemTitle?: string;
	itemValue?: string;
	clearable?: boolean;
	multiple?: boolean;
	density?: string;
	variant?: string;
	color?: string;
}

const props = withDefaults(defineProps<AutocompleteProps>(), {
	modelValue: undefined,
	label: undefined,
	itemTitle: undefined,
	itemValue: undefined,
	clearable: false,
	multiple: false,
	density: "compact",
	variant: "outlined",
	color: "primary",
});

// Define the emit for v-model
const emit = defineEmits<{
	"update:modelValue": [value: any];
}>();

// Handle model updates
const handleModelUpdate = (value: any) => {
	emit("update:modelValue", value);
};
</script>

<style lang="scss">
/* Custom styles for autocomplete component */
.custom-chips {
	.v-field__input {
		/* Original CSS restored but without the problematic selection hiding rule */
	}
}
</style>
